import aa from 'search-insights';
import { pushDataLayerEvent } from './DataUtil';

const ALGOLIA_APP_ID = 'O2VJB2KMPB';
const ALGOLIA_SEARCH_KEY = 'da4cad371de519f4a6244398d6d18c31';

export const getToken = () => {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(/(?:^|;\s*)_ALGOLIA=([^;]*)/i);
  return match ? decodeURIComponent(match[1]) : '';
};

export const initAlgoliaInsights = () => {
  if (typeof window === 'undefined') return;
  aa('init', {
    appId: ALGOLIA_APP_ID,
    apiKey: ALGOLIA_SEARCH_KEY,
    useCookie: true,
  });
  window.aa = aa;
};

export const pushAlgoliaUserTokenToGA4 = () => {
  const token = getToken();
  if (!token) return;
  pushDataLayerEvent('algolia_user_token_set', {
    algolia_user_token: token,
  });
};

export const sendClickedObjectIDsAfterSearch = (
  queryID,
  objectID,
  indexName,
  position
) => {
  if (typeof window === 'undefined' || !queryID || !objectID || !indexName)
    return;
  const userToken = getToken();
  if (!userToken) return;
  try {
    aa('clickedObjectIDsAfterSearch', {
      eventName: 'Search Result Clicked',
      index: indexName,
      queryID,
      objectIDs: [String(objectID)],
      positions: [typeof position === 'number' ? position : 1],
      userToken,
    });
  } catch (e) {
    console.error('Algolia click event failed:', e);
  }
};

export const sendNoResultsEvent = (queryID, indexName) => {
  if (typeof window === 'undefined' || !queryID || !indexName) return;
  const userToken = getToken();
  if (!userToken) return;
  try {
    aa('clickedObjectIDsAfterSearch', {
      eventName: 'No Results',
      index: indexName,
      queryID,
      objectIDs: ['no-results'],
      positions: [1],
      userToken,
    });
  } catch (e) {
    console.error('Algolia no-results event failed:', e);
  }
};
